<template>
  <div class="personedit" v-if="personedit">
    <div class="pagePopMask pFull" v-if="!showEditpop" @click.self="closePop"></div>
    <div class="pagePop w1280 pCenter" v-if="!showEditpop">
      <div class="w">
        <div class="tit fnt_32">{{ globalDataArray.siteTemplateLanguage.person_team_member }}</div>

        <div class="cont">
          <div class="compCommonInfo">
            <span class="">{{ globalDataArray.siteTemplateLanguage.team_name }}：{{ teamName }}</span>
            <span class="">{{ globalDataArray.siteTemplateLanguage.team_type }}：{{ teamType }}</span>
            <span class="">{{ globalDataArray.siteTemplateLanguage.create_time }}：{{ teamCreateTime }}</span>
          </div>

          <!-- 国内成人 -->
          <div class="antDesignTable gncr">
            <a-table
              row-key="id"
              :show-header="false"
              :pagination="false"
              :scroll="{x:true}"
              :columns="columns"
              :data-source="list"
              class="j-table-force-nowrap"
            >
              <template slot="one" slot-scope="text, record">
                <div class="captainLabel relative" :class="curLang != '' && curLang != 'zh_CN' ? 'rus' : ''" v-if="record.nation=='01'">
                  <div><span class="c-gray">{{ globalDataArray.siteTemplateLanguage.team_user_name }}：</span>{{ record.userName }}</div>
                  <div><span class="c-gray">{{ globalDataArray.siteTemplateLanguage.team_user_company_type }}：</span>{{ record.companyType_dictText }}</div>
                  <div class="label" v-if="record.isCaptain==1">{{ globalDataArray.siteTemplateLanguage.team_leader }}</div>
                </div>

                <div class="captainLabel relative" :class="curLang != '' && curLang != 'zh_CN' ? 'rus' : ''" v-if="record.nation=='02'">
                  <div><span class="c-gray">{{ globalDataArray.siteTemplateLanguage.team_user_name }}：</span>{{ record.userName }}</div>
                  <div class="label" v-if="record.isCaptain==1">{{ globalDataArray.siteTemplateLanguage.team_leader }}</div>
                </div>
              </template>
              <template slot="two" slot-scope="text, record">
                <div v-if="record.nation=='01'"><span class="c-gray">{{ globalDataArray.siteTemplateLanguage.team_user_phone }}：</span>{{ record.userPhone }}</div>
                <div v-if="record.nation=='01'">
                  <span class="c-gray" v-if="record.companyType=='02'">{{ globalDataArray.siteTemplateLanguage.team_member_school }}：</span>
                  <span class="c-gray" v-else>{{ globalDataArray.siteTemplateLanguage.team_user_company_name }}：</span>
                  {{ record.company }}
                </div>
              </template>
              <template slot="three" slot-scope="text, record">
                <div v-if="record.nation=='01'"><span class="c-gray">{{ globalDataArray.siteTemplateLanguage.team_user_email }}：</span>{{ record.userMail }}</div>
                <div v-if="record.jobType_dictText!=''&&record.jobType_dictText!=null"><span class="c-gray">{{ globalDataArray.siteTemplateLanguage.team_user_job_type }}：</span>{{ record.jobType_dictText }}</div>

                <div v-if="record.nation=='02'"><span class="c-gray">{{ globalDataArray.siteTemplateLanguage.team_user_email }}：</span>{{ record.userMail }}</div>
              </template>
              <template slot="four" slot-scope="text, record">
                <div>
                  <span class="c-gray">{{ globalDataArray.siteTemplateLanguage.person_area }}：</span>{{ record.countryName }}{{ record.cityName }}
                </div>
              </template>
              <!-- curid.competitionSignup=='03'报名中    record.isCaptain==0 && isEditOrDelete == 1 && curid.competitionDelflag=='0' && curid.competitionStatus=='1' && curid.competitionSignup=='03' && currentTime < curid.localEndtimeStr  -->
              <template slot="action" slot-scope="text, record">
                <div v-if="isEditOrDelete === 1 && curid.competitionDelflag == '0' && curid.competitionStatus== '1' && currentTime < curid.localEndtimeStr">
                  <div class="compEdit" @click="editFun(record.id)">{{ globalDataArray.siteTemplateLanguage.edit }}</div>
                  <div class="compDel" @click="delFun(record.id,record.competitionParentId,record.memberId,record.userMail,record.teamName)">
                    {{ globalDataArray.siteTemplateLanguage.delete }}
                  </div>
                  <div v-if="record.jobType === '02'" class="student_ant" @click="studentAnti(record)">学生认证</div>
                </div>
              </template>
            </a-table>
            <a-button @click="addUser" v-if="currentTime < curid.localEndtimeStr">添加成员</a-button>
            <a-pagination
              :v-model="current" :total="total"
              :page-size="pageSize"
              @change="turnPageFun" show-less-items
            />
            <!--               <a-pagination v-model:current="current" :total="500" /> -->
          </div>

          <!-- 国内青少年 -->
          <div class="antDesignTable qsn" v-if="templateId == '02' && nation == '01'">
            <a-table
              row-key="id"
              :show-header="false"
              :pagination="false"
              :scroll="{x:true}"
              :columns="columns"
              :data-source="list"
              class="j-table-force-nowrap"
            >
              <template slot="one" slot-scope="text, record">
                <div class="captainLabel relative" :class="curLang != '' && curLang != 'zh_CN' ? 'rus' : ''">
                  <div v-if="record.isleader"><span class="c-gray">{{ globalDataArray.siteTemplateLanguage.leader_name }}：</span>{{ record.leaderName }}</div>
                  <div v-else><span class="c-gray">{{ globalDataArray.siteTemplateLanguage.team_user_name }}：</span>{{ record.userName }}</div>
                  <div class="label" v-if="record.isleader">{{ globalDataArray.siteTemplateLanguage.leader_label }}</div>
                  <div class="label" v-if="record.isCaptain=='1'">{{ globalDataArray.siteTemplateLanguage.team_leader }}</div>
                </div>
              </template>
              <template slot="two" slot-scope="text, record">
              </template>
              <template slot="three" slot-scope="text, record">
                <div v-if="record.userPhone&&record.isleader"><span class="c-gray">{{ globalDataArray.siteTemplateLanguage.team_user_phone }}：</span>{{ record.userPhone }}</div>
                <div v-if="!record.isleader"><span class="c-gray">{{ globalDataArray.siteTemplateLanguage.team_member_school }}：</span>{{ record.company }}</div>
              </template>
              <template slot="four" slot-scope="text, record">
                <div v-if="!record.isleader">
                  <span class="c-gray">{{ globalDataArray.siteTemplateLanguage.person_area }}：</span>{{ record.countryName }}{{ record.cityName }}
                </div>
                <div v-if="record.userMail&&record.isleader"><span class="c-gray">{{ globalDataArray.siteTemplateLanguage.team_user_email }}：</span>{{ record.userMail }}</div>
              </template>
              <template slot="action" slot-scope="text, record" v-if="!record.isleader && isEditOrDelete == 1 && curid.competitionDelflag=='0' && curid.competitionStatus=='1' && curid.competitionSignup=='03' && currentTime < curid.localEndtimeStr">
                <div class="compEdit" @click="editFun(record.id)">{{ globalDataArray.siteTemplateLanguage.edit }}</div>
                <div class="compDel" v-if="record.isCaptain!='1'" @click="delFun(record.id,record.competitionParentId,record.memberId,record.userMail,record.teamName)">
                  {{ globalDataArray.siteTemplateLanguage.delete }}
                </div>
              </template>
            </a-table>
            <a-pagination
              :v-model="current" :total="total"
              :page-size="pageSize"
              @change="turnPageFun" show-less-items
            />
          </div>

          <!-- 国外青少年 -->
          <div class="antDesignTable gwqsn" v-if="templateId == '02' && nation == '02'">
            <a-table
              row-key="id"
              :show-header="false"
              :pagination="false"
              :scroll="{x:true}"
              :columns="columns"
              :data-source="list"
              class="j-table-force-nowrap"
            >
              <template slot="one" slot-scope="text, record">
                <div class="captainLabel relative" :class="curLang != '' && curLang != 'zh_CN' ? 'rus' : ''">
                  <div v-if="record.isleader"><span class="c-gray">{{ globalDataArray.siteTemplateLanguage.leader_name }}：</span>{{ record.leaderName }}</div>

                  <div v-else><span class="c-gray">{{ globalDataArray.siteTemplateLanguage.team_user_name }}：</span>{{ record.userName }}</div>
                  <div class="label" v-if="record.isleader">{{ globalDataArray.siteTemplateLanguage.leader_label }}</div>
                  <div class="label" v-if="record.isCaptain=='1'">{{ globalDataArray.siteTemplateLanguage.team_leader }}</div>
                </div>
              </template>
              <template slot="two" slot-scope="text, record">
              </template>
              <template slot="three" slot-scope="text, record">
                <div v-if="record.userPhone&&record.isleader"><span class="c-gray">{{ globalDataArray.siteTemplateLanguage.team_user_phone }}：</span>{{ record.userPhone }}</div>
                <div v-if="!record.isleader"><span class="c-gray">{{ globalDataArray.siteTemplateLanguage.team_member_school }}：</span>{{ record.company }}</div>
              </template>
              <template slot="four" slot-scope="text, record">
                <div v-if="!record.isleader">
                  <span class="c-gray">{{ globalDataArray.siteTemplateLanguage.person_area }}：</span>{{ record.countryName }}{{ record.cityName }}
                </div>
                <div v-if="record.userMail&&record.isleader"><span class="c-gray">{{ globalDataArray.siteTemplateLanguage.team_user_email }}：</span>{{ record.userMail }}</div>
              </template>
              <template slot="action" slot-scope="text, record" v-if="!record.isleader && isEditOrDelete == 1 && curid.competitionDelflag=='0' && curid.competitionStatus=='1' && curid.competitionSignup=='03' && currentTime < curid.localEndtimeStr">
                <div class="compEdit" @click="editFun(record.id)">{{ globalDataArray.siteTemplateLanguage.edit }}</div>
                <div class="compDel" v-if="record.isCaptain!='1'" @click="delFun(record.id,record.competitionParentId,record.memberId,record.userMail,record.teamName)">
                  {{ globalDataArray.siteTemplateLanguage.delete }}
                </div>
              </template>
            </a-table>
            <a-pagination
              :v-model="current" :total="total"
              :page-size="pageSize"
              @change="turnPageFun" show-less-items
            />
          </div>
        </div>

        <div class="close" @click.self="closePop"></div>
      </div>
    </div>

    <!-- 编辑成员信息弹窗 -->
    <div class="pagePopMask pFull" v-if="showEditpop" @click="cancelEdit"></div>
    <div class="pagePop w1280 pCenter" v-if="showEditpop">
      <div class="w">
        <div class="tit fnt_32">{{ globalDataArray.siteTemplateLanguage.person_team_member }}</div>
        <div class="cont">
          <div class="stform">
            <a-form :form="form" :model="userInfoArray">
              <a-row :gutter="18">
                <div v-for="item in teamMemberList" :key="item.fieldSort + 'n'" v-if="item.isShow === '1' || item.isDoubleCheck">
                  <a-col :xs="24" :sm="24" :md="item.isStandalone === '0' ? 12 : 24" :lg="item.isStandalone === '0' ? 12 : 24" :xl="item.isStandalone === '0' ? 12 : 24">
                    <a-form-item
                      :label="item.fieldName" :extra="item.prompt && item.prompt[0] ? item.prompt[0] : ''"
                    >
                      <!--              下拉框-->
                      <a-select
                        v-if="item.fieldCode === 'company' && item.isDoubleCheck"
                        show-search
                        allow-clear
                        :filter-option="false"
                        placeholder="请输入学校"
                        :get-popup-container="triggerNode => { return triggerNode.parentNode || document.body; }"
                        v-decorator="[`userInfoArray.${item.fieldCode}`, { rules: [{ required: true, message: '请选择' + item.fieldName + '!' }] }]"
                        @search="searchCollege"
                      >
                        <a-select-option v-for="fi in filterdCollegeList" :key="fi.identificationCode" :value="fi.name">
                          {{ fi.name }}
                        </a-select-option>
                      </a-select>
                      <a-select
                        :label-in-value="true"
                        placeholder="请选择" v-else-if="item.fieldCode === 'countryCode'" @change="handleProvinceChange1"
                        v-decorator="[`userInfoArray.${item.fieldCode}`, { rules: [{ required: item.verificationType, message: '请选择' + item.fieldName + '!' }] }]"
                      >
                        <a-select-option :value="po.parentId" v-for="po in item.list" :key="po.parentId">
                          {{ po.title }}
                        </a-select-option>
                      </a-select>
                      <a-select
                        :label-in-value="true"
                        placeholder="请选择" v-else-if="item.fieldCode === 'cityCode'"
                        v-decorator="[`userInfoArray.${item.fieldCode}`, { rules: [{ required: item.verificationType, message: '请选择' + item.fieldName + '!' }] }]"
                      >
                        <a-select-option :value="po.itemValue" v-for="po in item.list" :key="po.itemValue">
                          {{ po.itemText }}
                        </a-select-option>
                      </a-select>
                      <a-select
                        placeholder="请选择" v-else-if="item.fieldType === 'select'"
                        v-decorator="[`userInfoArray.${item.fieldCode}`, { rules: [{ required: item.verificationType, message: '请选择' + item.fieldName + '!' }] }]"
                      >
                        <a-select-option :value="po.itemValue" v-for="po in item.list" :key="po.itemValue">
                          {{ po.itemText }}
                        </a-select-option>
                      </a-select>
                      <!--              普通输入框-->
                      <a-input
                        v-else-if="item.fieldType === 'text' && item.verificationType === 'email'"
                        v-decorator="[`userInfoArray.${item.fieldCode}`, { rules: [
                          { validator: validateNumber, trigger: 'blur' },
                          { required: item.verificationType , message: '请输入' + item.fieldName + '!' }] }]"
                      />
                      <a-input
                        v-else-if="item.fieldType === 'text' && item.verificationType === 'idCard'"
                        v-decorator="[`userInfoArray.${item.fieldCode}`, { rules: [
                          { validator: validateID, trigger: 'blur' },
                          { required: item.verificationType , message: '请输入' + item.fieldName + '!' }] }]"
                      />
                      <a-input
                        v-else-if="item.fieldType === 'text' && item.verificationType === 'phone'"
                        v-decorator="[`userInfoArray.${item.fieldCode}`, { rules: [
                          { pattern: /^[0-9-+]+$/, message: '请输入正确的手机号格式' },
                          { required: item.verificationType , message: '请输入' + item.fieldName + '!' }] }]"
                      />
                      <a-input
                        v-else-if="item.fieldType === 'text'"
                        v-decorator="[`userInfoArray.${item.fieldCode}`, { rules: [{ required: item.verificationType , message: '请输入' + item.fieldName + '!' }] }]"
                      />
                      <!--              普通单选框-->
                      <a-radio-group
                        v-else-if="item.fieldType === 'radio' && item.fieldCode === 'companyType'"
                        @change="onChangeCompany"
                        v-decorator="[`userInfoArray.${item.fieldCode}`, { rules: [{ required: item.verificationType , message: '请选择' + item.fieldName + '!' }] }]"
                      >
                        <a-radio :value="ca.itemValue" v-for="(ca,index) in item.list" :key="ca.itemValue">
                          {{ ca.itemText }}
                        </a-radio>
                      </a-radio-group>
                      <a-radio-group
                        v-else-if="item.fieldType === 'radio'"
                        v-decorator="[`userInfoArray.${item.fieldCode}`, { rules: [{ required: item.verificationType , message: '请选择' + item.fieldName + '!' }] }]"
                      >
                        <a-radio :value="ca.itemValue" v-for="(ca,index) in item.list" :key="ca.itemValue">
                          {{ ca.itemText }}
                        </a-radio>
                      </a-radio-group>
                      <!--              文件上传-->
                      <a-upload
                        v-else-if="item.fieldType === 'upload'"
                        v-decorator="[`userInfoArray.${item.fieldCode}`,
                                      {
                                        getValueFromEvent: normFile,
                                        rules: [{ required: item.verificationType, message: '文件上传' }]
                                      }
                        ]"
                        name="file"
                        accept=".zip,.rar,.7z"
                        :file-list="item.fileList"
                        :remove="(file) => removeFiles1(file, item)"
                        :before-upload="(file) => beforeUpload1(file, item)"
                        :custom-request="customUpload"
                      >
                        <a-button :disabled="uploading" class="my-5">文件上传</a-button>
                      </a-upload>
                    </a-form-item>
                  </a-col>
                </div>
                <div v-if="captaionSwitch">
                  <a-col :xs="24" :sm="24" :md="24" :lg="24" :xl="24">
                    <a-divider>队长审核</a-divider>
                    <a-form-item label="审核状态">
                      <a-radio-group v-decorator="[`userInfoArray.checkStatus`, { rules: [{ required: true, message: '请选择审核状态' }] }]">
                        <a-radio :value="'02'">
                          审核通过
                        </a-radio>
                        <a-radio :value="'08'">
                          审核不通过
                        </a-radio>
                      </a-radio-group>
                    </a-form-item>
                    <a-form-item label="审核意见" v-show="form.getFieldValue('userInfoArray.checkStatus') === '08'">
                      <a-input v-decorator="[`userInfoArray.checkRemark`]" />
                    </a-form-item>
                  </a-col>
                </div>
              </a-row>

              <!--              <div class="item">
                <a-form-item :label="globalDataArray.siteTemplateLanguage.team_member_name">
                  <a-input
                    v-decorator="['userInfoArray.userName', {initialValue:userInfoArray.userName,rules:[{required:true,message:globalDataArray.siteTemplateLanguage.person_form_please_user_name}]}]"
                  />
                </a-form-item>
                <a-form-item :label="globalDataArray.siteTemplateLanguage.team_user_phone">
                  <a-input
                    v-decorator="['userInfoArray.userPhone',{initialValue:userInfoArray.userPhone,rules:[{required:true,message:globalDataArray.siteTemplateLanguage.enter_member_tel}]}]"
                  />
                </a-form-item>
              </div>

              <div class="item">
                <a-form-item :label="globalDataArray.siteTemplateLanguage.team_user_email">
                  <a-input
                    v-decorator="['userInfoArray.userMail',{initialValue:userInfoArray.userMail,rules:[{required:true,message:globalDataArray.siteTemplateLanguage.team_apply_user_email}]}]"
                  />
                </a-form-item>
                <a-form-item :label="globalDataArray.siteTemplateLanguage.team_user_company_type">
                  <a-radio-group @change="onChange" v-decorator="['userInfoArray.companyType', { initialValue:userInfoArray.companyType,rules: [{ required: true, message: globalDataArray.siteTemplateLanguage.person_please_form_company_type}] }]">
                    <a-radio :style="radioStyle" :value="item.itemValue" v-for="(item,index) in companyType" :key="index">{{ item.itemText }}</a-radio>
                  </a-radio-group>
                </a-form-item>
              </div>

              <a-form-item :label="globalDataArray.siteTemplateLanguage.team_member_school">
                <a-input
                  v-decorator="['userInfoArray.company',{initialValue:userInfoArray.company, rules:[{required:true,message:globalDataArray.siteTemplateLanguage.person_please_form_company_name}]}]"
                />
              </a-form-item>
              <a-form-item :label="globalDataArray.siteTemplateLanguage.team_user_job_type">
                <a-radio-group @change="onChange" v-decorator="['userInfoArray.jobType', {initialValue:userInfoArray.jobType }]">
                  <a-radio :style="radioStyle" :value="item.itemValue" v-for="(item,index) in jobType" :key="index">{{ item.itemText }}</a-radio>
                </a-radio-group>
              </a-form-item>
              <div class="item">
                <a-form-item :label="globalDataArray.siteTemplateLanguage.person_form_province">
                  <a-select :get-popup-container="triggerNode => { return triggerNode.parentNode || document.body;}" @change="handleProvinceChange" :label-in-value="true" v-decorator="['userInfoArray.countryCode', { initialValue:userInfoArray.countryCode, rules: [{ required: true, message: globalDataArray.siteTemplateLanguage.person_please_form_province }] }]">
                    <a-select-option v-for="prov in provinceList" :key="prov.parentId">
                      {{ prov.title }}
                    </a-select-option>
                  </a-select>
                </a-form-item>

                <a-form-item :label="globalDataArray.siteTemplateLanguage.team_user_city">
                  <a-select :get-popup-container="triggerNode => { return triggerNode.parentNode || document.body;}" :label-in-value="true" v-decorator="['userInfoArray.cityCode', { initialValue:userInfoArray.cityCode }]">
                    <a-select-option v-for="city in cityList" :key="city.parentId">
                      {{ city.title }}
                    </a-select-option>
                  </a-select>
                </a-form-item>
              </div>-->
            </a-form>
          </div>
        </div>
        <div class="cont" v-if="editTemplate == '02' && editNation == '01'">
          <div class="stform">
            <a-form :form="form">
              <a-form-item :label="globalDataArray.siteTemplateLanguage.team_member_name">
                <a-input
                  v-decorator="['userInfoArray.userName', {initialValue:userInfoArray.userName,rules:[{required:true,message:globalDataArray.siteTemplateLanguage.person_form_please_user_name}]}]"
                />
              </a-form-item>
              <a-form-item :label="globalDataArray.siteTemplateLanguage.team_member_school">
                <a-input
                  v-decorator="['userInfoArray.company',{initialValue:userInfoArray.company, rules:[{required:true,message:globalDataArray.siteTemplateLanguage.person_please_form_school_name}]}]"
                />
              </a-form-item>
              <div class="item">
                <a-form-item :label="globalDataArray.siteTemplateLanguage.person_form_province">
                  <a-select :get-popup-container="triggerNode => { return triggerNode.parentNode || document.body;}" @change="handleProvinceChange" :label-in-value="true" v-decorator="['userInfoArray.countryCode', { initialValue:userInfoArray.countryCode, rules: [{ required: true, message: globalDataArray.siteTemplateLanguage.person_please_form_province }] }]">
                    <a-select-option v-for="prov in provinceList" :key="prov.parentId">
                      {{ prov.title }}
                    </a-select-option>
                  </a-select>
                </a-form-item>

                <a-form-item :label="globalDataArray.siteTemplateLanguage.team_user_city">
                  <a-select :get-popup-container="triggerNode => { return triggerNode.parentNode || document.body;}" :label-in-value="true" v-decorator="['userInfoArray.cityCode', { initialValue:userInfoArray.cityCode }]">
                    <a-select-option v-for="city in cityList" :key="city.parentId">
                      {{ city.title }}
                    </a-select-option>
                  </a-select>
                </a-form-item>
              </div>
            </a-form>
          </div>
        </div>

        <div class="cont" v-if="editTemplate == '01' && editNation == '02'">
          <div class="stform">
            <a-form :form="form">
              <a-form-item :label="globalDataArray.siteTemplateLanguage.team_member_name">
                <a-input
                  v-decorator="['userInfoArray.userName', {initialValue:userInfoArray.userName,rules:[{required:true,message:globalDataArray.siteTemplateLanguage.person_form_please_user_name}]}]"
                />
              </a-form-item>

              <a-form-item :label="globalDataArray.siteTemplateLanguage.team_user_email">
                <a-input
                  v-decorator="['userInfoArray.userMail',{initialValue:userInfoArray.userMail,rules:[{required:true,message:globalDataArray.siteTemplateLanguage.team_apply_user_email}]}]"
                />
              </a-form-item>

              <div class="item">
                <a-form-item :label="globalDataArray.siteTemplateLanguage.person_form_country">
                  <a-select :get-popup-container="triggerNode => { return triggerNode.parentNode || document.body;}" @change="handleProvinceChange" :label-in-value="true" v-decorator="['userInfoArray.countryCode', { initialValue:userInfoArray.countryCode, rules: [{ required: true, message: globalDataArray.siteTemplateLanguage.person_please_form_country }] }]">
                    <a-select-option v-for="prov in provinceList" :key="prov.parentId">
                      {{ prov.title }}
                    </a-select-option>
                  </a-select>
                </a-form-item>

                <a-form-item :label="globalDataArray.siteTemplateLanguage.team_user_city">
                  <a-select :get-popup-container="triggerNode => { return triggerNode.parentNode || document.body;}" :label-in-value="true" v-decorator="['userInfoArray.cityCode', { initialValue:userInfoArray.cityCode }]">
                    <a-select-option v-for="city in cityList" :key="city.parentId">
                      {{ city.title }}
                    </a-select-option>
                  </a-select>
                </a-form-item>
              </div>
            </a-form>
          </div>
        </div>

        <div class="cont" v-if="editTemplate == '02' && editNation == '02'">
          <div class="stform">
            <a-form :form="form">
              <a-form-item :label="globalDataArray.siteTemplateLanguage.team_member_name">
                <a-input
                  v-decorator="['userInfoArray.userName', {initialValue:userInfoArray.userName,rules:[{required:true,message:globalDataArray.siteTemplateLanguage.person_form_please_user_name}]}]"
                />
              </a-form-item>

              <a-form-item :label="globalDataArray.siteTemplateLanguage.team_member_school">
                <a-input
                  v-decorator="['userInfoArray.company',{initialValue:userInfoArray.company, rules:[{required:true,message:globalDataArray.siteTemplateLanguage.person_please_form_school_name}]}]"
                />
              </a-form-item>

              <div class="item">
                <a-form-item :label="globalDataArray.siteTemplateLanguage.person_form_country">
                  <a-select :get-popup-container="triggerNode => { return triggerNode.parentNode || document.body;}" @change="handleProvinceChange" :label-in-value="true" v-decorator="['userInfoArray.countryCode', { initialValue:userInfoArray.countryCode, rules: [{ required: true, message: globalDataArray.siteTemplateLanguage.person_please_form_country }] }]">
                    <a-select-option v-for="prov in provinceList" :key="prov.parentId">
                      {{ prov.title }}
                    </a-select-option>
                  </a-select>
                </a-form-item>

                <a-form-item :label="globalDataArray.siteTemplateLanguage.team_user_city">
                  <a-select :get-popup-container="triggerNode => { return triggerNode.parentNode || document.body;}" :label-in-value="true" v-decorator="['userInfoArray.cityCode', { initialValue:userInfoArray.cityCode }]">
                    <a-select-option v-for="city in cityList" :key="city.parentId">
                      {{ city.title }}
                    </a-select-option>
                  </a-select>
                </a-form-item>
              </div>
            </a-form>
          </div>
        </div>
        <div class="btnBox fnt_18">
          <div class="btn btn1" @click="confirmEdit">{{ globalDataArray.siteTemplateLanguage.save }}</div>
          <div class="btn btn2" @click="cancelEdit">{{ globalDataArray.siteTemplateLanguage.cancel }}</div>
        </div>
        <div class="close" @click="cancelEdit"></div>
      </div>
    </div>
    <!-- 编辑成员信息弹窗 -->

    <!-- 学生认证弹窗 -->
    <StudentAuth ref="studentAuth" :info-pop.sync="studentPop" :form-student="studentInfo"/>
  </div>
</template>
<script>
import {
  teamRecord,
  selectOneTeamRecord,
  deleteTeamRecord,
  updateTeamRecord,
  addMember,
  studentVerification
} from '@/api/person/person'
import { getCompetitionDict, getProvinceList, getCityList } from '@/api/api'
import { Modal, message } from 'ant-design-vue'
import Cookies from 'js-cookie'
import { checkMember, getCollegeList, queryByParentId, uploadFile } from '@/api/saiti'
import StudentAuth from '@/components/global/personedit/StudentAuth.vue'
export default {
  name: 'Personedit',
  components: { StudentAuth },
  props: {
    personedit: {
      type: Boolean,
      default: false
    },
    curid: {
      type: Object,
      default: () => ({})
    }
  },
  data() {
    return {
      competitionId: '',
      parentId: '',
      memberId: '',
      userMail: '',
      teamName: '',
      currentTime: '', // 当前地区时区时间时间戳
      columns: [
        {
          scopedSlots: { customRender: 'one' }
        },
        {
          scopedSlots: { customRender: 'two' }
        },
        {
          scopedSlots: { customRender: 'three' }
        },
        {
          scopedSlots: { customRender: 'four' }
        },
        {
          title: '操作',
          dataIndex: 'action',
          align: 'center',
          fixed: 'right',
          scopedSlots: { customRender: 'action' }
        }
      ],
      list: [],

      form: this.$form.createForm(this, { name: 'dynamic_rule' }),
      formStudent: this.$form.createForm(this, { name: 'dynamic_rule_student' }),
      showEditpop: false,
      radioStyle: {
        display: 'block',
        height: '30px',
        lineHeight: '30px'
      },
      userInfoArray: {
        userName: '',
        userPhone: '',
        userMail: '',
        companyType: '',
        company: '',
        jobType: '',
        countryCode: '',
        cityCode: '',
        competitionId: '',
        parentId: ''
      },
      provinceList: [],
      cityList: {},
      // teamName: '',
      teamType: '',
      teamCreateTime: '',
      isEditOrDelete: 0,
      jobType: [],
      companyType: [],
      current: 1,
      total: 0,
      pageSize: 10,
      nation: '',
      templateId: '',

      leaderData: {}, // 处理青少年的leader数据
      curLang: '',

      editTemplate: '',
      editNation: '',
      isAdd: false,
      uploading: false,
      studentPop: false, // 学生认证弹窗
      studentInfo: {
        userMail: '',
        userPhone: '',
        code: '',
        url: []
      }, // 学生认证信息
      fileList: [], // 上传文件列表
      captaionSwitch: false, // 队长审核开关
      allList: [], // 全部字段信息
      dictCodeArray: [], // 字典值数组
      showList: [], // 队员固定列表
      teamMemberList: [], // 队员固定列表
      filterdCollegeList: [] // 过滤后的学校列表
    }
  },
  watch: {
    personedit: {
      immediate: true,
      handler(val) {
        if (val) {
          this.competitionId = this.curid.competitionParentId
          this.parentId = this.curid.parentId
          this.memberId = this.curid.memberId
          this.teamName = this.curid.teamName
          this.currentTime = new Date().getTime() // 当前地区时区时间时间戳
          this.teamRecord()
          console.log(this.curid, 'curid')
          // console.log(val,'111dsdsd')
          // 获取团队成员信息
          //
          const that = this
          const currentLanguge = Cookies.get('DEFAULT_LANG')
          if (currentLanguge != null && currentLanguge != undefined) {
            that.curLang = currentLanguge
          } else {
            that.curLang = that.globalDataArray.siteLanguage[0].value
          }
        }
      }
    }
  },
  mounted() {
    this.getCompetitionDict()

    // this.getCityList()
    this.getCollegeList()
  },
  methods: {
    teamRecord() {
      const that = this
      const params = 'competitionId=' + that.competitionId + '&parentId=' + that.parentId + '&page=' + that.current + '&pageSize=' + that.pageSize
      // let param="page="+that.paginationOpt.current+"&pageSize="+that.paginationOpt.defaultPageSize
      teamRecord(params).then(res => {
        if (res.success) {
          that.list = res.result.records
          that.total = res.result.total
          that.current = res.result.current
          if (that.list.length > 0) {
            that.teamName = that.list[0].teamName
            that.teamType = that.list[0].teamType_dictText
            that.teamCreateTime = that.list[0].createTime
            that.isEditOrDelete = that.list[0].isEditOrDelete

            that.nation = res.result.records[0].nation // 01国内02国外
            that.templateId = res.result.records[0].templateId // 01成人02青少年

            if (that.list[0].templateId == '02') {
              const list = that.list

              that.leaderData['isleader'] = true
              if (that.list[0].leaderName && that.list[0].leaderName != '') {
                that.leaderData['leaderName'] = that.list[0].leaderName
              }
              if (that.list[0].userMail && that.list[0].userMail != '') {
                that.leaderData['userMail'] = that.list[0].userMail
              }
              if (that.list[0].userPhone && that.list[0].userPhone != '') {
                that.leaderData['userPhone'] = that.list[0].userPhone
              }

              const leaderArr = []
              leaderArr.push(that.leaderData)
              list.forEach((item, index) => {
                item['isleader'] = false
                leaderArr.push(item)
              })
              that.list = leaderArr
              // console.log(that.list)
            }
          }
          const teamMemberListCopy = []
          this.list.forEach(item => {
            if (item.isCaptain === 1) {
              const leaderObj = structuredClone(this.showList)
              leaderObj.forEach(leader => {

              })
            } else {
              console.log(item, 'item')
            }
          })
          console.log(that.list, 'list')
        }
      })
      // 初始化省或国家列表
      this.getProvinceList()
      this.findAllColunm()
    },

    // 获取模板信息
    findAllColunm() {
      const paTemp = 'language=' + this.globalDataArray.siteInfo.language + '&templateId=' + this.curid.templateId
      queryByParentId(paTemp).then(res => {
        if (res.success) {
          // 全部字段信息
          this.allList = JSON.parse(res.result.fieldJson)
          // 获取所有字典值
          this.allList.forEach(item => {
            // 检查 item 中是否有 dictCode 属性
            if (item.dictCode) {
              // 将 dictCode 数据添加到数组中
              this.dictCodeArray.push(item.dictCode)
            }
          })
          this.findDictCode()
        }
      })
    },

    // 给字段值绑定字典列表
    findDictCode() {
      const param = 'dictCode=' + this.dictCodeArray.join(',')
      getCompetitionDict(param).then(res => {
        if (res.success) {
          const dictCodeList = res.result
          this.allList = this.allList.map(showItem => {
            const dictItem = dictCodeList.find(dictItem => dictItem.dictCode === showItem.dictCode)
            if (dictItem) {
              showItem.list = dictItem.list
            }
            if (showItem.fieldType === 'upload') {
              showItem.fileList = []
            }
            if (showItem.fieldCode === 'countryCode') {
              showItem.list = this.provinceList
              console.log(showItem, this.provinceList)
            }
            return showItem
          })
          this.showList = this.allList.filter(item => item.isTeam === 0)
          const teamMemberListCopy = JSON.parse(JSON.stringify(this.showList))
          teamMemberListCopy.forEach(item => {
            if (item.fieldCode === 'leaderName') {
              item.fieldName = '队员'
              item.fieldCode = 'userName'
            }
          })
          this.teamMemberList = teamMemberListCopy
          console.log(this.showList, 'mmmmmm')
          console.log(this.teamMemberList, 'zzzzz')
        }
      })
    },

    getCompetitionDict() {
      const that = this
      const params = 'dictCode=competition_signup_job_type,competition_signup_company_type'
      getCompetitionDict(params).then(res => {
        if (res.success) {
          const result = res.result
          for (var i = 0; i < result.length; i++) {
            if (result[i].dictCode == 'competition_signup_company_type') {
              that.companyType = result[i].list
            } else {
              that.jobType = result[i].list
            }
          }
        }
      })
    },
    getProvinceList() {
      const that = this

      getProvinceList().then(res => {
        if (res.success) {
          // let result = res.result
          that.provinceList = res.result
          // console.log(result,'area')
        }
      })
    },
    getCityList(pid, list) {
      const cityParams = 'pid=' + pid
      getCityList(cityParams).then(res => {
        if (res.success) {
          list.forEach(item => {
            if (item.fieldCode === 'cityCode') {
              // item.list = res.result
              this.$set(item, 'list', res.result)
            }
          })
        }
      })
      console.log(list, 'listgetcitylist')
      console.log(this.showList, 'listgetcitylist')
    },
    editFun(id, status) {
      const that = this
      const params = 'id=' + id
      selectOneTeamRecord(params).then(res => {
        if (res.success) {
          that.editTemplate = res.result.template_id
          that.editNation = res.result.nation

          that.showEditpop = true
          // that.userInfoArray.userName = res.result.user_name
          // that.userInfoArray.userPhone = res.result.user_phone
          // that.userInfoArray.userMail = res.result.user_mail
          // that.userInfoArray.companyType = res.result.company_type
          // that.userInfoArray.company = res.result.company
          // that.userInfoArray.jobType = res.result.job_type
          // that.userInfoArray.countryCode = res.result.country_code
          // that.userInfoArray.cityCode = res.result.city_code
          // that.userInfoArray.competitionId = res.result.competition_id
          // that.userInfoArray.id = res.result.id
          const jsonObjcect = JSON.parse(res.result.sigup_json)
          const event = {
            target: {
              value: jsonObjcect.companyType
            }
          }
          this.onChangeCompany(event)

          setTimeout(() => {
            // 数据回填
            const ccCode = {
              key: res.result.country_code,
              label: res.result.country_name
            }

            let ctCode = ''
            if (res.result.city_code != '' && res.result.city_code != null) {
              ctCode = {
                key: res.result.city_code,
                label: res.result.city_name
              }
            }
            console.log(jsonObjcect, 'jsonObjcect')

            // 构造表单值对象
            const formValues = {}
            // 将 JSON 数据映射到表单字段
            Object.keys(jsonObjcect).forEach(key => {
              formValues[`userInfoArray.${key}`] = jsonObjcect[key]
            })
            formValues['userInfoArray.countryCode'] = ccCode
            formValues['userInfoArray.cityCode'] = ctCode
            // 一次性设置所有表单值
            this.form.setFieldsValue(formValues)
            this.userInfoArray = jsonObjcect
            this.userInfoArray.id = res.result.id
            this.userInfoArray.checkStatus = status
          })

          that.getCityList(that.userInfoArray.countryCode, that.userInfoArray.isCaptain === 1 ? that.showList : that.teamMemberList)
        }
      })
    },

    // 队长审核
    captainReview(record) {
      this.captaionSwitch = true
      const params = 'id=' + record.id
      selectOneTeamRecord(params).then(res => {
        if (res.success) {
          this.showEditpop = true
          const jsonData = JSON.parse(res.result.sigup_json)
          const jsonObjcect = JSON.parse(record.sigupJson)
          console.log(jsonData, 'jsonData')
          console.log(jsonObjcect, 'jsonObjcect')
          jsonObjcect.idCard = jsonData.idCard
          jsonObjcect.userPhone = jsonData.userPhone
          jsonObjcect.userMail = jsonData.userMail
          jsonObjcect.id = record.id
          const event = {
            target: {
              value: jsonObjcect.companyType
            }
          }
          this.onChangeCompany(event)
          // 构造表单值对象
          const formValues = {}
          // 将 JSON 数据映射到表单字段
          Object.keys(jsonObjcect).forEach(key => {
            formValues[`userInfoArray.${key}`] = jsonObjcect[key]
          })
          if (jsonObjcect.countryCode) {
            const ccCode = {
              key: jsonObjcect.countryCode,
              label: jsonObjcect.countryName
            }
            formValues['userInfoArray.countryCode'] = ccCode
          }
          if (jsonObjcect.cityCode) {
            const ctCode = {
              key: jsonObjcect.cityCode,
              label: jsonObjcect.cityName
            }
            formValues['userInfoArray.cityCode'] = ctCode
          }

          this.$nextTick(() => {
            // 一次性设置所有表单值
            this.form.setFieldsValue(formValues)
            this.userInfoArray = jsonObjcect
          })
        }
      })
    },

    turnPageFun(e) {
      const that = this
      that.current = e
      that.teamRecord()
    },
    cancelEdit() {
      const that = this
      that.showEditpop = false
      that.captaionSwitch = false
      this.$emit('SignupRecordList')
    },

    confirmEdit() {
      const that = this
      that.form.validateFields((err, val) => {
        // console.log(val)
        if (!err) {
          val.userInfoArray.competitionId = that.userInfoArray.competitionId
          val.userInfoArray.id = that.userInfoArray.id

          if (val.userInfoArray.countryCode) {
            const countryKL = val.userInfoArray.countryCode
            if (countryKL.key) {
              val.userInfoArray['countryCode'] = countryKL.key
            }
            if (countryKL.label) {
              val.userInfoArray['countryName'] = countryKL.label
            }
          }

          if (val.userInfoArray.cityCode) {
            const cityKL = val.userInfoArray.cityCode
            if (cityKL.key) {
              val.userInfoArray['cityCode'] = cityKL.key
            }
            if (cityKL.label) {
              val.userInfoArray['cityName'] = cityKL.label
            }
          } else {
            val.userInfoArray['cityCode'] = ''
            val.userInfoArray['cityName'] = ''
          }

          val.userInfoArray.categoryId = that.curid.categoryId
          val.userInfoArray.competitionId = that.curid.competitionId
          val.userInfoArray.templateId = that.curid.templateId
          val.userInfoArray.currentLanguge = that.curid.currentLanguge
          val.userInfoArray.teamsUsers = that.curid.teamsUsers
          val.userInfoArray.teams = that.curid.teams
          val.userInfoArray.parentId = that.curid.parentId
          val.userInfoArray.zoneId = that.curid.zoneId
          val.userInfoArray.teamName = that.curid.teamName
          val.userInfoArray.teamType = that.curid.teamType

          let params = val.userInfoArray
          console.log(that.curid, 'curid')
          console.log(that.list, 'list')
          if (that.isAdd) {
            params.leaderName = that.curid.leaderName
            params.isCaptain = 0
            delete params.id
            params.sigupJson = JSON.stringify(params)
            console.log(params, 'params')
            addMember(params).then(res => {
              if (res.success) {
                message.success(res.result)
                that.isAdd = false
                that.showEditpop = false
                that.teamRecord()
                that.userInfoArray = {}
              } else {
                message.error(res.message)
              }
            })
          } else if (that.captaionSwitch) {
            const newParams = {}
            newParams.id = params.id
            newParams.checkRemark = params.checkRemark
            newParams.checkStatus = params.checkStatus
            newParams.competitionId = params.competitionId
            newParams.parentId = that.list[0].id
            checkMember(newParams).then(res => {
              if (res.success) {
                message.success(res.message)
                that.captaionSwitch = false
                that.showEditpop = false
                that.teamRecord()
                that.userInfoArray = {}
              } else {
                message.error(res.message)
              }
            })
            console.log(params, 'params')
          } else {
            params = { ...this.userInfoArray, ...params }
            if (params.checkStatus === '08') {
              params.checkStatus = '09'
            }
            params.sigupJson = JSON.stringify(params)
            console.log(val.userInfoArray, 'val.userInfoArray')
            console.log(this.userInfoArray, 'this.userInfoArray')
            console.log(params, 'params')
            // console.log(params)
            updateTeamRecord(params).then(res => {
              if (res.success) {
                that.showEditpop = false
                message.success(res.result)
                that.teamRecord()
              } else {
                message.error(res.message)
              }
            })
            that.userInfoArray = {}
            that.showEditpop = false
          }
        }
      })
    },

    delFun(id, competitionId, memberId, userMail, teamName) {
      // console.log(id,competitionId,memberId,userMail,teamName,'del')
      const that = this
      Modal.confirm({
        title: that.globalDataArray.siteTemplateLanguage.person_delete_user,
        content: '',
        okText: that.globalDataArray.siteTemplateLanguage.verify,
        cancelText: that.globalDataArray.siteTemplateLanguage.cancel,
        onOk() {
          const params = {
            'id': id,
            'memberId': memberId,
            'userMail': userMail,
            'competitionId': competitionId,
            'teamName': teamName
          }
          deleteTeamRecord(params).then(res => {
            if (res.success) {
              message.success(res.result)
              that.teamRecord()
            } else {
              message.error(res.result)
            }
          })
        },
        onCancel() {
          console.log('Cancel')
        }
      })
    },

    // 学生认证弹框
    studentAnti(record) {
      console.log(record, 'anti')
      this.studentPop = true
      this.studentInfo = record
      this.studentInfo.url = []
      this.$refs.studentAuth.init(record)
    },

    // 测试变化是获取值公共方法，不参功能
    onChange(e) {
      // console.log(e.target.value)
    },

    // 省市联动
    handleProvinceChange(ind) {
      const that = this

      that.getCityList(ind.key, true)

      setTimeout(() => {
        // 选择后清空二级
        this.form.setFieldsValue({
          'userInfoArray.cityCode': ''
        })
      })
    },

    // 省市联动
    handleProvinceChange1(e) {
      console.log(e)
      const that = this
      const params = 'pid=' + e.key + '&language=' + this.globalDataArray.siteInfo.language
      getCityList(params).then(res => {
        if (res.success) {
          that.teamMemberList.forEach(item => {
            if (item.fieldCode === 'cityCode') {
              res.result.forEach(ca => {
                ca.itemValue = ca.id
                ca.itemText = ca.title
              })
              item.list = res.result
            }
          })
          setTimeout(() => {
            // 选择后清空二级
            this.form.setFieldsValue({
              'userInfoArray.cityCode': ''
            })
          })
        }
      })
    },

    closePop() {
      this.$emit('update:personedit', false)
      this.$emit('SignupRecordList')
    },

    async getCollegeList() {
      const { success, result, message } = await getCollegeList()

      if (success) {
        this.collegeList = result
      }
    },

    searchCollege(value) {
      if (!value) {
        return
      }

      this.filterdCollegeList = this.collegeList.filter(item => {
        if (item.name.indexOf(value) > -1) {
          return true
        }
        return false
      })
    },

    // 验证输入的字符串是否符合中国的身份证号码格式。身份证号码可以是15位或18位数字，其中18位的最后一位可以是数字或字母X（大小写均可）
    validateID(rule, value, callback) {
      const regID = new RegExp(/(^\d{15}$)|(^\d{18}$)|(^\d{17}(\d|X|x)$)/)
      if (value != '' && value != undefined && !regID.test(value)) {
        callback(new Error('请输入正确的身份证格式 '))
      } else {
        callback()
      }
    },

    validateNumber(rule, value, callback) {
      const regMail = new RegExp('^([a-zA-Z0-9._%-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,6}(\.[a-zA-Z]{2,6})?)$')
      if (value != '' && value != undefined && !regMail.test(value)) {
        callback(new Error(this.globalDataArray.siteTemplateLanguage.mail_format_error))
      } else {
        callback()
      }
    },

    // 上传文件
    normFile(e) {
      return (e && e.fileList?.[0]?.response) ?? ''
    },

    // 删除上传文件
    removeFiles1(e, item) {
      item.fileList = []
    },

    beforeUpload1(file, item) {
      if (item.fileList.length > 0) {
        message.error(this.globalDataArray.siteTemplateLanguage.only_upload_one)
        return false
      }
      if (!/\.(?:zip|rar|7z)$/.test(file.name)) {
        message.error(this.globalDataArray.siteTemplateLanguage.file_format_error)

        return false
      }
      if (file.size > 1024 * 1024 * 10) {
        message.error(this.globalDataArray.siteTemplateLanguage.file_size_error)

        return false
      }
      item.fileList.push(file)
      return true
    },

    async customUpload(e) {
      const formData = new FormData()

      formData.append('file', e.file)

      this.uploading = true

      const { success, result, message } = await uploadFile(formData)

      this.uploading = false

      if (success) {
        e.onSuccess(result, e)
      }
      else {
        e.onError(message)
      }
    },

    removeFiles() {
      this.fileList = []
    },

    beforeUpload(file) {
      if (this.fileList.length > 0) {
        message.error(this.globalDataArray.siteTemplateLanguage.only_upload_one)

        return false
      }

      if (!/\.(?:pdf)$/.test(file.name)) {
        message.error(this.globalDataArray.siteTemplateLanguage.file_format_error)

        return false
      }

      if (file.size > 1024 * 1024 * 10) {
        message.error(this.globalDataArray.siteTemplateLanguage.file_size_error)

        return false
      }

      this.fileList.push(file)

      return true
    },

    // 切换单位类型
    onChangeCompany(e) {
      const newValue = e.target.value !== '02' ? '1' : '0'
      this.teamMemberList.forEach(item => {
        if (item.fieldCode === 'company') {
          item.isShow = newValue
          item.isDoubleCheck = e.target.value === '02'
        }
      })
    },

    // 添加成员
    addUser() {
      console.log('addUser')
      this.isAdd = true
      this.showEditpop = true
    }
  }
}
</script>
<style lang="scss" scoped>
::v-deep .pagePop .cont {
  max-height: 63vh;
  height: auto;
}
.student_ant {
  width: 82px;
  color: #687389;
  cursor: pointer;
}
</style>
